import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";

const About_Education_Award = () => {
  return (
    <>
      <Banner />
      <div className="home_header">
        <h1 className="home_header">OUR AWARDS</h1>
      </div>

      <div className="about_info">
        <p>
          It is a premier accolade awarded by TIME Cyber Media that recognizes
          innovation and confers honors for excellence in the field of
          <br />
          education. While it salutes the education community for its dedicated
          effort towards the cause of education, TIME Cyber Media also created
          <br />
          this event platform to build a forum that would bring together all the
          stakeholders from this sector to further the discussion on development
          <br />
          in the field of education. The 21st century is known as "the century
          of knowledge" and we aim to give due recognition and rewards to those
          <br />
          individuals and organizations that have contributed to this global
          goal. International Education Award celebrates the hard work,
          dedication,
          <br />
          innovation and high standards of Indian education sector. They
          recognize the achievements of people who dedicate their lives to
          children
          <br />
          and young people and showcase the valuable work and innovation in
          classrooms. The award function brings together leaders from the
          <br />
          education industry and assists in building a strong community by
          providing various business and networking opportunities for clients,
          <br />
          partners and students. These awards intend to inspire others towards
          bigger and better achievements by rewarding those who set an industry best benchmark.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default About_Education_Award;
